import { Row, Col } from "antd";

import FiltersButton from "./filtersButton";
import ColumnsButton from "./columnsButton";
import SnapshotsButton from "./snapshotsButton";
import ExportButton from "./exportButton";
import DataButton from "./dataButton";
import Title from "./title";
import { Report, Workflow, Integration } from "/app/src/models";
import PermissionIcons from "./permissionIcons";
import ReportUsage from "./reportUsage";

/**
 * Renders the controls component with various buttons and titles.
 * @param {Object} props - The properties for the Controls component.
 * @param {Report} props.report - The report object used for displaying the title.
 * @param {number} props.columnsCount - The number of columns to display in the ColumnsButton.
 * @param {number} props.filtersCount - The number of filters to display in the FiltersButton.
 * @param {number} props.snapshotsCount - The number of snapshots to display in the SnapshotsButton.
 * @param {Workflow[]} props.activeWorkflows - Active workflows using this report.
 * @param {Workflow[]} props.inactiveWorkflows - Inactive workflows using this report.
 * @param {Integration[]} props.activeIntegrations - Active integrations using this report.
 * @param {Integration[]} props.inactiveIntegrations - Inactive integrations using this report.
 * @returns {JSX.Element} The rendered controls component.
 */
export default function Controls({
  report,
  columnsCount,
  filtersCount,
  snapshotsCount,
  activeWorkflows,
  inactiveWorkflows,
  activeIntegrations,
  inactiveIntegrations,
}: {
  report: Report;
  columnsCount: number;
  filtersCount: number;
  snapshotsCount: number;
  activeWorkflows?: Workflow[];
  inactiveWorkflows?: Workflow[];
  activeIntegrations?: Integration[];
  inactiveIntegrations?: Integration[];
}) {
  return (
    <div className="controls">
      <Row align="bottom">
        <Col>
          <Title report={report} />
        </Col>
        <Col flex="auto" className="controlTabs">
          <Row>
            <Col span={24} style={{ marginBottom: "15px" }}>
              <div className="flex gap-2 justify-end ml-auto">
                <ReportUsage
                  activeWorkflows={activeWorkflows}
                  inactiveWorkflows={inactiveWorkflows}
                  activeIntegrations={activeIntegrations}
                  inactiveIntegrations={inactiveIntegrations}
                />
                <PermissionIcons />
              </div>
            </Col>
            <Col span={24}>
              <FiltersButton filtersCount={filtersCount} />
              <ColumnsButton columnsCount={columnsCount} />
              <SnapshotsButton snapshotsCount={snapshotsCount} />
              <ExportButton />
              <DataButton />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
